<!-- Dummy element for autofocus -->
@if (currentGeneralData) {
  <div class="modal-wrapper" [class.st-drawer-in-mobile]="!!drawerRef">
    <!-- Header -->
    <div class="st-modal-header">
      <p>{{currentGeneralData.title}}</p>
      <button class="flex-center" nz-button [nzSize]="(isMobile$ | async) ? 'default' : 'large'" nzType="text"
              nzShape="circle" (click)="close()">
        <app-st-icon [bold]="true" name="close"></app-st-icon>
      </button>

    </div>

    <!-- Content -->
    <div class="st-modal-content">
      <ng-container [ngSwitch]="docModalType">

        <!-- Upload -->
        <ng-template [ngSwitchCase]="'upload'">

          <!-- Upload Component -->
          <ng-container [ngTemplateOutlet]="nzUploadTmpl"></ng-container>

          <!-- Mostrar la lista de formularios para que el usuario seleccione el tipo de documento para cada archivo -->
          <ng-container [ngTemplateOutlet]="uploadListTmpl"></ng-container>

        </ng-template>

        <!-- Correct -->
        <ng-template [ngSwitchCase]="'correct'">

          <!-- Upload Component -->
          <ng-container [ngTemplateOutlet]="nzUploadTmpl"></ng-container>

          <!-- Mostrar la lista de formularios para que el usuario seleccione el tipo de documento para cada archivo -->
          <ng-container [ngTemplateOutlet]="uploadListTmpl"></ng-container>

          <!-- Documento a corregir -->
          <div class="correct-doc-wrapper">
            <p>Se va a reemplazar el siguiente documento:</p>
            <div>
              <div>
                <app-st-icon [color]="'#8F8F8F'" [avatar]="true" [bold]="true" name="scan_delete"></app-st-icon>
                <div class="doc-info flex">
                <strong>{{document!.type}}</strong>
                <span>·</span>
                <label>{{document!.name}}</label>
                </div>
              </div>

              <app-st-icon [bold]="true" name="arrow_forward"></app-st-icon>

              <div>
                <app-st-icon [color]="'#666666'" [avatar]="true" [bold]="true" name="description"></app-st-icon>
                <div class="doc-info flex">
                <strong>{{document!.type}}</strong>
                <span>·</span>
                <label>{{uploadForms.length > 0 ? uploadForms[0].file.name : '-'}}</label>
                </div>
              </div>
            </div>
          </div>

        </ng-template>

        <!-- Validate -->
        <ng-template [ngSwitchCase]="'validate'">
          <div  class="flex flex-column gap-200">
            <p class="info-text">
              ¿Estás seguro que quieres validar el documento? Podrás rechazarlo o volver a pendiente de validación más adelante si lo necesitas.</p>

            <ng-container [ngTemplateOutlet]="docNameTmpl" [ngTemplateOutletContext]="{ $implicit: document }"></ng-container>
          </div>
        </ng-template>

        <!-- Reject -->
        <ng-template [ngSwitchCase]="'reject'">
          <div class="flex flex-column gap-200">
            <p class="info-text">¿Estás seguro que quieres rechazar el documento? Tendrá que volver a subirse.</p>
            <ng-container [ngTemplateOutlet]="docNameTmpl" [ngTemplateOutletContext]="{ $implicit: document }"></ng-container>
            <p class="info-text">Para garantizar que se vuelva a subir el documento con los requisitos, es necesario detallar a continuación los motivos del rechazo.</p>
            <span class="text-label-10">Motivo</span>
            <textarea [(ngModel)]="rejectReason" rows="4" nz-input class="info-text"
                      placeholder="El documento no es válido porque..."></textarea>
          </div>
        </ng-template>

        <!-- Return -->
        <ng-template [ngSwitchCase]="'return'">
          <div  class="flex flex-column gap-200">
            <p class="info-text">
              ¿Quieres volver a marcar el documento como pendiente de validación? El validador tendrá que volver a validar el documento.</p>

            <ng-container [ngTemplateOutlet]="docNameTmpl" [ngTemplateOutletContext]="{ $implicit: document }"></ng-container>

<!--            <p class="info-text">Para garantizar que se vuelva a subir el documento con los requisitos, es necesario detallar a continuación los motivos del rechazo.</p>-->
<!--            <span class="text-label-10">Motivo</span>-->
<!--            <textarea [(ngModel)]="rejectReason" rows="4" nz-input class="info-text"-->
<!--                      placeholder="El documento no es válido porque..."></textarea>-->
          </div>
        </ng-template>

        <!-- Delete -->
        <ng-template [ngSwitchCase]="'delete'">
          <p class="info-text">
            ¿Estás seguro que desea eliminar {{ documentsToDelete!.length > 1 ? 'los documentos' : 'el documento' }}? </p>
          <br>
          <p style="margin-right: 15px; margin-bottom: 12px" class="info-text">
            Esta operación es irreversible y {{ documentsToDelete!.length > 1 ? 'los documentos no se podrán' : 'el documento no se podrá' }} recuperar.</p>
          @if (documentsToDelete!.length > 1) {
            <div class="flex flex-column gap-200">
              @for (doc of documentsToDelete; track doc.id) {
                <ng-container [ngTemplateOutlet]="docNameTmpl" [ngTemplateOutletContext]="{ $implicit: doc }"></ng-container>
              }
            </div>
          }
        </ng-template>

        <ng-template ngSwitchDefault>
          <p>No tenemos este tipo de Modal.</p>
        </ng-template>
      </ng-container>
    </div>


    <!-- Footer -->
    <div class="st-modal-footer">
      <button *ngIf="!drawerRef" nz-button nzSize="large" nzType="text" nzShape="round" (click)="close()">
        Cancelar
      </button>

      <button nz-button nzSize="large" nzType="primary" nzShape="round" class="flex-center"
              (click)="onConfirm()" [nzDanger]="docModalType === 'delete'"
              [disabled]="(docModalType === 'upload' || docModalType === 'correct') ? !allFormsValid
                            : ((docModalType !== 'return' && docModalType !== 'validate' && docModalType !== 'delete') ? !rejectReason : false)">
        <app-st-icon *ngIf="!!currentGeneralData!.actionIcon && !loading" style="margin-right: 8px" [bold]="true"
                     [name]="currentGeneralData!.actionIcon"></app-st-icon>
        <app-st-icon style="margin-right: 8px" *ngIf="loading" name="progress_activity"></app-st-icon>
        <span>{{currentGeneralData!.actionTitle}}</span>
      </button>
    </div>
  </div>
}

<ng-template #notificationTmpl>
  <app-toast *ngIf="notRef" [icon]="toastConfig.icon" [iconColor]="toastConfig.iconColor" [showUndo]="toastConfig.showUndo"
             [notRef]="notRef" [content]="toastConfig.content" [msg]="toastConfig.msg"></app-toast>
</ng-template>

<ng-template #nzUploadTmpl>
  <nz-upload
    #uploadComponent
    nzType="drag"
    [nzShowUploadList]="false"
    [nzMultiple]="!document"
    [nzCustomRequest]="customUpload"
    (nzChange)="handleUploadChange($event)"
  >
    <div class="ant-upload-drag-icon">
      <app-st-icon [bold]="true" name="upload"></app-st-icon>
    </div>
    <p class="ant-upload-text">{{ (isMobile$ | async) ? 'Pulsa para subir documentos.' : 'Arrastra a esta ventana o haz click para subir documentos.' }}</p>
  </nz-upload>
</ng-template>

<ng-template #uploadListTmpl>
  <div *ngIf="uploadForms.length > 0" class="upload-list-wrapper">
    @for (form of uploadForms; track form.file.name) {
      <div>
        <nz-card>
          <app-st-icon [avatar]="true" [bold]="true" name="description"></app-st-icon>
          <span *ngIf="form.status === 'pending'">{{form.file.name}}</span>
          <nz-progress *ngIf="form.status !== 'pending'" nzType="line" [nzShowInfo]="false" nzSize="default"
                       [nzStrokeWidth]="4" [nzPercent]="form.progress"
                       [nzStrokeColor]="form.status === 'uploading' ? '#0068D6'
                                                  : (form.status === 'success' ? '#45DEC5' : '#DA2F35')"
          ></nz-progress>
        </nz-card>

        <div *ngIf="!onlyReturnFiles" class="select-wrapper">
          <nz-select class="larger" [(ngModel)]="form.documentType" [nzSize]="(isMobile$ | async) ? 'default' : 'large'"
                     [nzDisabled]="!!document || !!documentType" [nzSuffixIcon]="customSelectIcon" nzShowSearch
                     nzPlaceHolder="Selecciona el tipo de documento">
            <nz-option *ngFor="let opt of documentTypes" [nzLabel]="opt.name" [nzValue]="opt.name"></nz-option>
            <ng-template #customSelectIcon>
              <app-st-icon class="custom-suffix" name="keyboard_arrow_down"></app-st-icon>
            </ng-template>
          </nz-select>
          <span>Tipo de documento</span>
        </div>

        <div *ngIf="!onlyReturnFiles" class="select-wrapper partner-select">
          <nz-date-picker class="larger" [(ngModel)]="form.expirationDate"
                          [nzSize]="(isMobile$ | async) ? 'default' : 'large'"
                          nzFormat="dd-MM-yyyy"
                          nzPlaceHolder="Selecciona la fecha de expiración"
          ></nz-date-picker>

          <span>Fecha de expiración</span>
        </div>

        <button nz-button nzSize="large" class="larger" nzType="text" nzShape="circle" (click)="deleteDocumentToUpload(form)" nzDanger>
          <app-st-icon [bold]="true" name="delete"></app-st-icon>
        </button>
      </div>
    }
  </div>
</ng-template>

<ng-template #docNameTmpl let-document>
  <div class="doc-name">
    <app-st-icon [color]="'#666666'" [avatar]="true" [bold]="true" name="description"></app-st-icon>
    <div class="doc-info flex">
      <strong>{{document!.type}}</strong>
      <span>·</span>
      <label class="text-nowrap">{{document!.name}}</label>
    </div>
  </div>
</ng-template>




